module.exports = __webpack_public_path__ + "img/bt_title1.e7119618.png";